import React, { Component } from 'react';
import { Label } from 'atoms/Texts';
import { FormSelect, FormTxt } from 'atoms/Inputs';
import { ButtonReg } from 'atoms/Buttons';
import IconPng from 'atoms/IconPng';
import Breadcrumb from 'molecules/Breadcrumb';
import { getAllUsersLogData } from 'Redux/actions/UserTrafficLogAction';
import { toggleIsLoading } from 'Redux/actions/ViewStateActions';
import { setLocalSettingsTableData } from 'Redux/actions/SettingsTableActions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  PageWrapper,
  RoundedWrapper,
  FilterCol,
  FilterRow,
  StyledDatePicker,
  TimeWrapper,
  TimeSeparatorLabel,
  StyledTimePicker,
  TableWrapper
} from './styles';
import { withTheme } from 'styled-components';
import lo from 'lodash';
import DataTables from 'organisms/DataTable';
import { tableIdFormatter } from 'components/molecules/TableFormatters/tableIdFormatter';
import moment from 'moment';
import LogDetail from './LogDetail';

const ic_eye = require('App/assets/images/ic_eye.png')
const defaultFilter =  {
  action: '-',
  username: '',
  date: '',
  startDate: '',
  endDate: '',
  table: '',
}
const btnIcons = {
  ic_arrow_down: require('App/assets/images/ic_arrow_down.png'),
  ic_arrow_right: require('App/assets/images/ic_arrow_right.png')
}
class UserTrafficPage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      filter: defaultFilter,
      lookups: {
        ACTION: [
          {value: 'CREATE', label: 'Create', color: this.props.theme.mocaGreen},
          {value: 'UPDATE', label: 'Update', color: this.props.theme.mocaOrange},
          {value: 'DELETE', label: 'Delete', color: this.props.theme.mocaRed},
        ],
      },
      navList: [
        'User Traffic Log',
        'User Traffic Log List'
      ],
    }
  }

  componentDidMount() {
    this.props.toggleIsLoading(true)
    this.props.getAllUsersLogData()
  }

  componentDidUpdate(prevProps) {
    const { usersTrafficLogList, viewState: { isLoading } } = this.props
    if (prevProps.usersTrafficLogList !== usersTrafficLogList && isLoading) {
      this.props.toggleIsLoading(false)
    }
  }

  // change filter state
  onFilterChange(val, field) {
    this.setState({
      filter: {
        ...this.state.filter,
        [field]: val
      }
    })
  }

  // view log based on filter
  onFilterSubmit() {
    this.props.toggleIsLoading(true)
    let query = ''
    const isFilterChange = Object
      .values(this.state.filter)
      .filter(d => ['','-'].indexOf(d) < 0)
      .length !== 0
    if (isFilterChange) {
      let filters = lo.pickBy(this.state.filter, (val) => [undefined,'','-',null].indexOf(val) < 0)
      const filterdate = filters.date ? moment(filters.date).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')

      if(filters.startDate) {
        filters.startDate = moment(`${filterdate} ${filters.startDate}`, 'YYYY-MM-DD hh:mm').toISOString()
      } else {
        if (filters.date) {
          filters.startDate = moment(`${filterdate} 00:00`).toISOString()
        }
      }

      if(filters.endDate) {
        filters.endDate = moment(`${filterdate} ${filters.endDate}`, 'YYYY-MM-DD hh:mm').toISOString()
      } else {
        if (filters.date) {
          filters.endDate = moment(`${filterdate} 24:00`).toISOString()
        }
      }
      const {date, ...newFilter} = filters
      const queryString = new URLSearchParams(newFilter).toString()
      query = `?${queryString}`
    }
    this.props.getAllUsersLogData(query)
  }

  //  filter
  onResetFilter() {
    this.props.toggleIsLoading(true)
    this.setState({ filter: defaultFilter }, () => {
      this.props.getAllUsersLogData()
    })
  }

  onSizePerPageChange = (size) => {
    const { setLocalSettingsTableData, settingsTable } = this.props
    const settings = lo.cloneDeep(settingsTable)
    settings.sizePerPage[this.state.navList[0]] = size
    setLocalSettingsTableData(settings)
  }

  renderFilterRow() {
    const inputConfig = {
      border: this.props.theme.mocaGrey,
      rad: '6px',
      width: 'auto',
      yxPadding: '9px 12px',
      height: '34px',
    }
    const { filter, lookups } = this.state

    return (
      <FilterRow>
        {Object.keys(filter).map((key, i) => {
          if (key === 'date') {
            return (
              <FilterCol>
                <Label lineheight={'14px'} size={'12px'}>
                  Date
                </Label>
                <StyledDatePicker
                  onChange={date => this.onFilterChange(date, 'date')}
                  value={this.state.filter.date}
                  format="dd/MM/yyyy"
                />
              </FilterCol>
            )
          }
          if (key === 'endDate') return null
          if (key === 'startDate') {
            return (
                <FilterCol>
                  <TimeWrapper>
                    <FilterCol>
                      <Label lineheight={'14px'} size={'12px'}>
                        Time
                      </Label>
                      <StyledTimePicker
                        onChange={date => this.onFilterChange(date, 'startDate')}
                        value={this.state.startDate}
                        timeInputLabel="Enter Time"
                        format="HH:mm"
                        disableClock
                      />
                    </FilterCol>
                    <FilterCol>
                      <Label lineheight={'14px'} size={'12px'}>
                        &nbsp;
                      </Label>
                      <TimeSeparatorLabel>
                        to
                      </TimeSeparatorLabel>
                    </FilterCol>
                    <FilterCol>
                      <Label lineheight={'14px'} size={'12px'}>
                        &nbsp;
                      </Label>
                      <StyledTimePicker
                        onChange={date => this.onFilterChange(date, 'endDate')}
                        value={this.state.filter.endDate}
                        timeInputLabel="Enter Time"
                        format="HH:mm"
                        disableClock
                      />
                    </FilterCol>
                  </TimeWrapper>
                </FilterCol>
            )
          }
          if (key === 'action') {
          return (
            <FilterCol key={i}>
              <Label lineheight={'14px'} size={'12px'}>
                {`${lo.capitalize(key.split('_')[0])} ${key.split('_')[1] || ''}`}
              </Label>
              <FormSelect
                placeholder={`Select ${lo.capitalize(key.split('_')[0])} ${key.split('_')[1] || ''}`}
                onChangeVal={e => this.onFilterChange(e.target.value, key)}
                options={lookups.ACTION}
                value={filter[key]}
                valField={'value'}
                dispField={'label'}
                {...inputConfig}
              />
            </FilterCol>
          )
          }
          return (
            <FilterCol key={i}>
              <Label lineheight={'14px'} size={'12px'}>
                {`${lo.capitalize(key.split('_')[0])} ${key.split('_')[1] || ''}`}
              </Label>
              <FormTxt
                placeholder={`Enter ${lo.capitalize(key.split('_')[0])} ${key.split('_')[1] || ''}`}
                value={filter[key]}
                onChangeVal={e => this.onFilterChange(e.target.value, key)}
                {...inputConfig}
              />
            </FilterCol>
          )
        })}
        <ButtonReg
          btnTxt={
            <IconPng srcIcon={ic_eye} ml={'0'} mb={'3px'} size={'auto'} h={'13'} showPointer={true} />
          }
          rad={'6px'}
          disabled={false}
          onClick={this.onFilterSubmit.bind(this)}
          width={'34px'}
          height={'34px'}
          margin={'0 9px 0 0'}
        />
        <ButtonReg
          btnTxt="Reset"
          rad={'6px'}
          disabled={false}
          onClick={this.onResetFilter.bind(this)}
          height={'34px'}
          width={'50px'}
        />
      </FilterRow>
    )
  }

  render() {
    const { navList } = this.state
    const { usersTrafficLogList, settingsTable, viewState: { isLoading, isMobileView } } = this.props

    const sizePerPage = settingsTable.sizePerPage[navList[0]]

    const config = [
      {
        dataField: 'loginName',
        text: 'Login Name',
        sort: true
      },
      {
        dataField: 'lastLogin',
        text: 'Last Login',
        formatter: (cell, row, rowIndex, formatExtraData) => {
          return <div>{row.lastLogin ? moment(row.lastLogin).format('DD/MM/YYYY - h:mm A') : '-'}</div>
        },
        formatExtraData: {
          field: 'lastLogin'
        },
        sort: true
      },
      {
        dataField: 'action',
        text: 'Action',
        formatter: tableIdFormatter,
        formatExtraData: {
          options: this.state.lookups.ACTION,
          field: 'action'
        },
        sort: true
      },
      {
        dataField: 'createdAt',
        formatter: (cell, row, rowIndex, formatExtraData) => {
        return <div>{moment(row[formatExtraData.field]).format('DD/MM/YYYY')}</div>
        },
        formatExtraData: {
          field: 'createdAt'
        },
        text: 'Date',
        sort: true
      },
      {
        dataField: 'createdBy', // cant have same key
        text: 'Time',
        formatter: (cell, row, rowIndex, formatExtraData) => {
          return <div>{moment(row[formatExtraData.field]).format('h:mm A')}</div>
        },
        formatExtraData: {
          field: 'createdAt'
        },
        sort: false
      },
      {
        dataField: 'className',
        text: 'Table ID',
        sort: true
      },
    ]

    const expandRow = {
      className: 'mx-0 px-0 bg-white',
      renderer: row => (
        <LogDetail
          {...{row, isMobileView}}
        />
      ),
      showExpandColumn: true,
      expandColumnRenderer: ({ expanded }) => {
        if (expanded) {
          return (
            <IconPng srcIcon={btnIcons.ic_arrow_down} showPointer={true} mx={'8px'} size={'auto'} h={'7'} />
          );
        }
        return (
          <IconPng srcIcon={btnIcons.ic_arrow_right} showPointer={true} mx={'8px'} size={'auto'} h={'11'}/>
        );
      }
    };

    return (
      <PageWrapper isMobile={isMobileView}>
        <Breadcrumb navList={navList} />
        {!isLoading &&
          <>
          <RoundedWrapper>
            {this.renderFilterRow()}
          </RoundedWrapper>
          <div className={'col-12 px-0 pt-3 text-center'}>
            <TableWrapper>
              <DataTables
                minWidth={'700px'}
                expandRow={expandRow}
                isMobile={isMobileView}
                dataList={usersTrafficLogList}
                columnConfig={config}
                sizePerPage={sizePerPage}
                onSizePerPageChange={this.onSizePerPageChange}
              />
            </TableWrapper>
          </div>
          </>
        }
      </PageWrapper>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    usersTrafficLogList: state.usersTrafficLogList,
    viewState: state.viewState,
    settingsTable: state.settingsTable
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getAllUsersLogData,
      toggleIsLoading,
      setLocalSettingsTableData,
    },
    dispatch
  )

export default withTheme(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(UserTrafficPage)
);
